// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pick-dialog-content {
    max-height: 70vh;
    min-width: 640px;
    overflow: auto;
    padding: 2px 24px !important;
    background-color: #f0f0f0;
}

.content {
    padding: 16px;
    border-radius: 4px;
}

.pick-section {
    margin-bottom: 14px;
}

.pick-section-title {
    margin-bottom: 6px;
    font-size: 13px;
    line-height: 22px;
}

.pick-list-container {
    border: 1px solid #c8c8c8;
    background: #fff;
    padding: 8px;
    max-height: 220px;
    overflow: auto;
}

.pick-group-block { margin-bottom: 6px; }

.pick-group-items {
    margin-left: 28px;
    margin-top: 4px;
}

.pick-empty {
    font-size: 13px;
    line-height: 22px;
}

.pick-list-container p {
    display: flex;
    align-items: flex-start;
    gap: 4px;
    margin: 0;
}

.pick-list-container p:last-child { margin-bottom: 0; }

.pick-list-container input[type="checkbox"] {
    flex: 0 0 auto;
    margin-top: 3px;
}

.pick-list-container label {
    flex: 1 1 auto;
    margin-bottom: 0;
    min-width: 0;
    font-size: 13px;
    line-height: 22px;
    text-transform: none !important;
}

.pick-dialog-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    background-color: #f0f0f0;
    padding: 8px 24px !important;
}

.pick-dialog-actions .button {
    width: auto !important;
    flex: none;
}

@media (max-width: 768px) {
    .pick-dialog-content { min-width: auto; }
}

@media (max-width: 768px) {
  .pick-dialog-content {
    min-width: auto;
  }
}

/* --- NextPage branded checkboxes --- */

form.branded input:not(.no-brand)[type="checkbox"],
input.branded[type="checkbox"] {
  margin-right: 0;
  vertical-align: middle;
}

form.branded input:not(.no-brand)[type="checkbox"]::before,
input.branded[type="checkbox"]::before {
  background-color: #fff;
  border-color: #0066b2;
}

form.branded input:not(.no-brand)[type="checkbox"]:checked::before,
input.branded[type="checkbox"]:checked::before {
  background-color: #0066b2;
  border-color: #0066b2;
}

form.branded input:not(.no-brand)[type="checkbox"]:checked::after,
input.branded[type="checkbox"]:checked::after {
  border-color: #fff;
}

form.branded input:not(.no-brand)[type="checkbox"] + label,
input.branded[type="checkbox"] + label {
  vertical-align: middle;
}

`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/manage-qaqc-readings/pick-spacer-qaqc-titles-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA,oBAAoB,kBAAkB,EAAE;;AAExC;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,SAAS;AACb;;AAEA,oCAAoC,gBAAgB,EAAE;;AAEtD;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,uBAAuB,eAAe,EAAE;AAC5C;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,wCAAwC;;AAExC;;EAEE,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;AACxB","sourcesContent":[".pick-dialog-content {\n    max-height: 70vh;\n    min-width: 640px;\n    overflow: auto;\n    padding: 2px 24px !important;\n    background-color: #f0f0f0;\n}\n\n.content {\n    padding: 16px;\n    border-radius: 4px;\n}\n\n.pick-section {\n    margin-bottom: 14px;\n}\n\n.pick-section-title {\n    margin-bottom: 6px;\n    font-size: 13px;\n    line-height: 22px;\n}\n\n.pick-list-container {\n    border: 1px solid #c8c8c8;\n    background: #fff;\n    padding: 8px;\n    max-height: 220px;\n    overflow: auto;\n}\n\n.pick-group-block { margin-bottom: 6px; }\n\n.pick-group-items {\n    margin-left: 28px;\n    margin-top: 4px;\n}\n\n.pick-empty {\n    font-size: 13px;\n    line-height: 22px;\n}\n\n.pick-list-container p {\n    display: flex;\n    align-items: flex-start;\n    gap: 4px;\n    margin: 0;\n}\n\n.pick-list-container p:last-child { margin-bottom: 0; }\n\n.pick-list-container input[type=\"checkbox\"] {\n    flex: 0 0 auto;\n    margin-top: 3px;\n}\n\n.pick-list-container label {\n    flex: 1 1 auto;\n    margin-bottom: 0;\n    min-width: 0;\n    font-size: 13px;\n    line-height: 22px;\n    text-transform: none !important;\n}\n\n.pick-dialog-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    background-color: #f0f0f0;\n    padding: 8px 24px !important;\n}\n\n.pick-dialog-actions .button {\n    width: auto !important;\n    flex: none;\n}\n\n@media (max-width: 768px) {\n    .pick-dialog-content { min-width: auto; }\n}\n\n@media (max-width: 768px) {\n  .pick-dialog-content {\n    min-width: auto;\n  }\n}\n\n/* --- NextPage branded checkboxes --- */\n\nform.branded input:not(.no-brand)[type=\"checkbox\"],\ninput.branded[type=\"checkbox\"] {\n  margin-right: 0;\n  vertical-align: middle;\n}\n\nform.branded input:not(.no-brand)[type=\"checkbox\"]::before,\ninput.branded[type=\"checkbox\"]::before {\n  background-color: #fff;\n  border-color: #0066b2;\n}\n\nform.branded input:not(.no-brand)[type=\"checkbox\"]:checked::before,\ninput.branded[type=\"checkbox\"]:checked::before {\n  background-color: #0066b2;\n  border-color: #0066b2;\n}\n\nform.branded input:not(.no-brand)[type=\"checkbox\"]:checked::after,\ninput.branded[type=\"checkbox\"]:checked::after {\n  border-color: #fff;\n}\n\nform.branded input:not(.no-brand)[type=\"checkbox\"] + label,\ninput.branded[type=\"checkbox\"] + label {\n  vertical-align: middle;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
